export default __webpack_public_path__ + "static/media/12.9257900b.png";